import { defineStore } from 'pinia'
import { SHIPPING_METHOD } from '@/constants/shipping.js'

export const useCartStore = defineStore('cart', {
  state: () => ({
    shippingMethod: '',
    pickupLocation: '',
    hasValidShippingMethod: true,
    hasValidShippingAddress: true,
    isBillingAddress: false,
    isActiveCartAddress: false,
    customerSetOnCart: false,
    shippingAddressSetOnCart: false,
    marketSetOnCart: false,
    stockLocationOnCart: false,
    itemStatusColours: [],
    shippingAddress: {},
    billingAddress: {},
    hasInvalidStockItems: false,
    awaitCaseSelectionItems: [],
    cityVouchers: false,
    deliveryMarketObject: {
      deliveryMethod: SHIPPING_METHOD.PICKUP,
      stockLocationAddressId: '',
      code: '',
      name: '',
      metadata: {
        line_1: '',
        line_2: '',
        zip_code: '',
        city: ''
      }
    }
  }),
  getters: {
    getShippingMethod: (state) => state.shippingMethod,
    getPickupLocation: (state) => state.pickupLocation,
    getShippingAddress: (state) => state.shippingAddress,
    getBillingAddress: (state) => state.billingAddress,
    getDeliveryMarketObject: (state) => state.deliveryMarketObject
  },
  actions: {
    setShippingAddress(address) {
      this.shippingAddress = address
    },
    setBillingAddress(address) {
      this.billingAddress = address
    },
    updateDeliveryMarketObject(marketData) {
      // Replace the entire object to ensure reactivity
      this.deliveryMarketObject = {
        deliveryMethod:
          marketData.deliveryMethod !== undefined
            ? marketData.deliveryMethod
            : this.deliveryMarketObject.deliveryMethod,
        stockLocationAddressId:
          marketData.stockLocationAddressId !== undefined
            ? marketData.stockLocationAddressId
            : this.deliveryMarketObject.stockLocationAddressId,
        code: marketData.code !== undefined ? marketData.code : this.deliveryMarketObject.code,
        name: marketData.name !== undefined ? marketData.name : this.deliveryMarketObject.name,
        metadata:
          marketData.metadata !== undefined
            ? { ...marketData.metadata }
            : this.deliveryMarketObject.metadata
      }

      // Update pickupLocation separately
      if (marketData.code !== undefined) {
        this.pickupLocation = marketData.code
      }
    },
    resetDeliveryMarketObject() {
      this.deliveryMarketObject = {
        deliveryMethod: SHIPPING_METHOD.PICKUP,
        marketName: '',
        stockLocationAddressId: '',
        code: '',
        name: '',
        metadata: {
          line_1: '',
          line_2: '',
          zip_code: '',
          city: ''
        }
      }
    }
  }
})
